export default __webpack_public_path__ + "static/media/CarService.bcf7796c.jpg";